// Shim for tests
if (typeof BASE_URL === "undefined") {
    var BASE_URL = '..';
    var API_VERSION = '1';
}

// URL configuration for interacting with the PBC Pharmacy Compass API
const baseUrl = `${BASE_URL}/api/v${API_VERSION}`;

// all endpoints called on PBC data
export const endpoints = {
    drugs: `${baseUrl}/drugs`,
    pharmacies: `${baseUrl}/pharmacies`
}

// specifies default number of results requested from database lookups
export const NUM_RESULTS = 10;

// used to get places data, minimum search radius, units in m
export const PLACES_SEARCH_RADIUS = 200;

// Default location is PBC headquarters in Burnaby, BC, Canada
export const DEFAULT_LOCATION = {
    lat: 49.2609375,
    lng: -123.1139278
}

// Zoom levels for google maps
export const DEFAULT_ZOOM = 14;
export const MAX_ZOOM = 16;
export const MIN_ZOOM = 5;

// Allow satellite/other map types for google maps
export const MAP_TYPE_CONTROL = false;

// Default image for a pharmacy when a photo isn't returned
export const DEFAULT_PROVIDER_IMAGE = `${BASE_URL}/app/` + require('../images/defaultProviderImage.jpg');

// Google Maps libraries
var libraries = ['places', 'geometry'];
export const googleMapsLibraries = libraries.join();

// Load indicator type, see Loaders.css for options
export const loaderType = 'ball-spin-fade-loader';

// Catch radius for zooming to markers
export const MAX_ZOOM_RADIUS = 5;

// Links for various spots
export const PBC_LOGO_LINK = 'https://www.pac.bluecross.ca';
export const PC_LOGO_LINK = 'https://pharmacycompass.ca';
export const FAQ_LINK = `https://www.pac.bluecross.ca/pharmacycompassres/faq.aspx`;
export const TAC_LINK = `https://www.pac.bluecross.ca/pharmacycompassres/tac.aspx`;
export const PREFERRED_FAQ_LINK = `${FAQ_LINK}#preferred-pharmacy`;
export const SA_FAQ_LINK = `${FAQ_LINK}#special-authority`;
export const BUY_GENERIC = `${FAQ_LINK}#why-generic`;



// WEBPACK FOOTER //
// ../D:/builds/ACES/Pharmacy Compass Production Support/PharmacyCompass2/Content/scripts/config.js